import { Link } from 'react-router-dom';

const DataCenter = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Data Center Products &amp; Solutions</h1>
          <p>
            Designing and operating data centers that deliver availability, scalability, and energy efficiency for the
            most demanding workloads.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container two-column">
          <div>
            <h2>High-Performance Facilities</h2>
            <p>
              Nexus IT builds and modernizes data centers through modular designs, robust infrastructure, and optimized
              operations. We integrate technologies that extend resilience, simplify management, and support growth.
            </p>
            <ul className="checklist">
              <li>White space design, containment, and rack optimization</li>
              <li>Precision cooling, environmental monitoring, and DCIM integration</li>
              <li>Power systems including UPS, generators, and intelligent PDUs</li>
              <li>Disaster recovery planning and multi-site replication</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>Operational Excellence</h3>
            <ul>
              <li>Capacity planning and energy efficiency analytics</li>
              <li>24/7 monitoring with predictive maintenance insights</li>
              <li>Compliance with ISO, TIA, and Tier certifications</li>
              <li>Lifecycle services from build to managed operations</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Specialized Expertise</span>
            <h2 className="section-title">Data Center Focus Areas</h2>
          </div>
          <div className="service-grid">
            <article className="service-card">
              <h3>New Build &amp; Expansion</h3>
              <p>Greenfield and brownfield projects with modular, scalable architectures.</p>
            </article>
            <article className="service-card">
              <h3>Migration &amp; Consolidation</h3>
              <p>Smooth transitions to optimized infrastructure with minimal downtime.</p>
            </article>
            <article className="service-card">
              <h3>High-Density Computing</h3>
              <p>Solutions for HPC, AI, and virtualization with precision cooling and power management.</p>
            </article>
            <article className="service-card">
              <h3>Business Continuity</h3>
              <p>Resilient architectures, redundancy strategies, and comprehensive DR planning.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Scale with Confidence</h2>
              <p>Leverage Nexus IT to build sustainable, future-ready data centers aligned with your growth trajectory.</p>
            </div>
            <Link className="btn btn-primary" to="/contact">
              Schedule a Workshop
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default DataCenter;
